export interface MessageData {
  id: number;
  image: string;
  message: string;
  name: string;
}

const messageData: MessageData[] = [];
export default messageData;
